export default function Users(Restangular, PersonaCollection, sdk, dateFilter) {
  'ngInject';

  const extendUserModel = sdk('model-extensions/extendUserModel');

  Restangular.extendModel('users', (user) => {
    if (typeof user === 'string') {
      return user;
    }

    return extendUserModel(user);
  });

  let _groups;

  Restangular.addFullRequestInterceptor(
    (element, operation, what, url, headers, params, httpConfig) => {
      if (what === 'users') {
        if (operation === 'post' || operation === 'put') {
          httpConfig._hiddenOnSchedule = element.hiddenOnSchedule;

          // We need to combine all groups, locations and positions into "groups" when sending to the server
          element.groups = Array.prototype
            .concat(element.groups, element.locations, element.positions)
            .filter((group) => group);

          // Send time-less birthdate and hireDate
          if (element.birthdayDate) {
            element.birthdayDate = dateFilter(element.birthdayDate, 'yyyy-MM-dd');
          }

          if (element.hireDate) {
            element.hireDate = dateFilter(element.hireDate, 'yyyy-MM-dd');
          }

          if ('hoursCap' in element && !element.hoursCap) {
            element.hoursCap = 0;
          }

          _groups = element.groups;
        }

        // Do NOT send a payload for the DELETE, see https://github.com/getsling/sling-server/issues/1369
        if (operation === 'remove') {
          return null;
        }
      }

      return element;
    }
  );

  // Update PersonaCollection and group memberships based on server response
  Restangular.addResponseInterceptor((data, operation, what, url, httpConfig) => {
    if (what === 'users') {
      if (operation === 'post') {
        PersonaCollection.addUser(data);
      }

      if (operation === 'put') {
        data.groups = _groups;
        const users = Array.isArray(data) ? data : [data];
        users.forEach((user) => {
          if (user.deleted) {
            PersonaCollection.deleteUser(user);
          } else {
            PersonaCollection.editUser(user);
            if ('_hiddenOnSchedule' in httpConfig.config) {
              PersonaCollection.personasDict[user.id].hiddenOnSchedule =
                httpConfig.config._hiddenOnSchedule;
            }
          }
        });
      }

      if (operation === 'remove') {
        PersonaCollection.deleteUser(data);
      }
    }

    if (what === 'users/bulk' && operation === 'post') {
      data.groups.forEach((group) => {
        if (
          (group.type === 'position' || group.type === 'location') &&
          !PersonaCollection.personasDict[group.id]
        ) {
          group.members = [];
          PersonaCollection.addGroup(group);
        }
      });

      data.users.forEach(PersonaCollection.addUser);
    }

    return data;
  });

  return Restangular.service('users');
}
